import { IOption } from '../../components/forms/search-input/BpSearchInput'

export type TOptionKind = 'keyword' | 'affiliate' | 'advertiser' | 'landing' | 'page'

/**
 * Названия уже виденных опций по типу. Подсказки приходят с сервера под строку поиска,
 * а выбранные id должны оставаться в поле со своими именами, даже когда их нет в текущем ответе.
 * Id уникальны в пределах типа, поэтому кеш общий для всех экранов.
 */
const known: Record<TOptionKind, Map<string, IOption>> = {
  keyword: new Map(),
  affiliate: new Map(),
  advertiser: new Map(),
  // filter/advertiser-landing
  landing: new Map(),
  // language-compliance/filter-page
  page: new Map(),
}

/** Опции мультивыбора по id: текущие подсказки плюс выбранные значения, которых в них нет. */
export const withSelectedOptions = (
  kind: TOptionKind,
  options: IOption[] = [],
  value?: string,
): IOption[] => {
  const cache = known[kind]

  options.forEach((option) => cache.set(option.value, option))

  const selected = value ? value.split(',').filter(Boolean) : []
  const missing = selected
    .filter((id) => !options.some((option) => option.value === id))
    .map((id) => cache.get(id) ?? { text: id, value: id })

  return missing.length ? [...missing, ...options] : options
}

/** Названия выбранных id через запятую — для ручек, которые по-прежнему фильтруют по тексту. */
export const selectedOptionTexts = (kind: TOptionKind, value?: string): string | undefined => {
  const texts = (value ? value.split(',').filter(Boolean) : []).map(
    (id) => known[kind].get(id)?.text ?? id,
  )

  return texts.length ? texts.join(',') : undefined
}
